export const DEFAULT_FONT = 'Inter';
